import initialstate from '../initialstate';
import {normalize, truthyWinsMergeStrategy} from '../../util/utils';
import * as types from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';

export function estimatesReducer(state = initialstate.estimates, action) {
	switch (action.type) {
		case types.GET_ESTIMATES: {
			if (action.response && action.response.data) {
				const estimatesList = normalize(
					action.response.data.map((estimate) => ({
						...estimate
					}))
				);
				estimatesList.page = action.response.page;
				estimatesList.pages = action.response.pages;
				estimatesList.totalEntityCount = action.response.totalEntityCount;

				return estimatesList;
			}
			return state;
		}
		case types.GET_ESTIMATE_BY_ID: {
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return {
					...normalize([action.response], undefined, state, truthyWinsMergeStrategy)
				};
			}
			return state;
		}
		case types.DELETE_ESTIMATE_DOCUMENT_BY_ID: {
			if (action) {
				return {
					...state,
					byId: {
						...state.byId,
						[action.entityUId]: {
							...state.byId[action.entityUId],
							relatedDocuments: state.byId[action.entityUId]?.relatedDocuments?.filter(
								(doc) => doc.documentID != action.documentId
							)
						}
					}
				};
			}
			return state;
		}
		default: {
			return state;
		}
	}
}
